import { StyleSheet } from "react-native";

import { Flex, Box, Text, StarRating } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";
import { CondensedRatingInfo } from "../CondensedRatingInfo";
import { NewTabReviewRating } from "../NewTabReviewRating";
import { TextLink } from "../TextLink/TextLink";

const styles = StyleSheet.create({
  starRatingContainer: { flexDirection: "row", alignItems: "center" },
});

export function CompanyRatingSection({
  country = "",
  disableAcmeLink = false,
}: {
  country?: string;
  disableAcmeLink?: boolean;
}) {
  const viewjobOneGraphModel = useViewjobOneGraphModel();
  const { ratings, companyReviewLink } = viewjobOneGraphModel?.employer ?? {};
  const { isSimpleVjImproveActive, isCondensedRating } = viewjobOneGraphModel?.features ?? {};
  const containerStyle = { marginRight: 8 };
  const i18n = useI18n();

  if (!ratings || !(ratings.count > 0)) {
    return null;
  }

  if (isCondensedRating) {
    return <CondensedRatingInfo rating={ratings.rating.toString()} />;
  }

  const starRatingLabel = i18n.gettext("{0} out of 5 stars", [ratings.rating.toString()]);

  if (isSimpleVjImproveActive && country === "JP") {
    return (
      <Box sx={containerStyle}>
        <Flex sx={styles.starRatingContainer}>
          <Box sx={{ marginRight: 4 }}>
            <StarRating value={ratings.rating} size="sm" ariaLabel={starRatingLabel} />
          </Box>

          {!isSimpleVjImproveActive && !disableAcmeLink && companyReviewLink ? (
            <Text level={1}>
              <TextLink
                data-testid={"inlineHeader-companyReviewLink"}
                targetUrl={companyReviewLink}
              >
                {ratings.countContent}
              </TextLink>
            </Text>
          ) : (
            <Text data-testid={"inlineHeader-companyReviewCounts"} level={3}>
              {ratings.countContent}
            </Text>
          )}
        </Flex>
      </Box>
    );
  }
  if (companyReviewLink) {
    return (
      <NewTabReviewRating
        rating={ratings.rating}
        reviewLink={companyReviewLink}
        countContent={ratings.countContent}
        ariaContent={ratings.ariaContent}
      />
    );
  }

  return <Text level={3}>{ratings.countContent}</Text>;
}
